/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { ImageSourceHelper } from '@sortlist-frontend/media';
import { Fragment, useCallback, useState } from 'react';

import { WorkDetailModal } from '_components/common/WorkDetailModal/WorkDetailModal';
import { onImageError } from '_core/media/get-media.utils';
import * as S from '_features/AgencyProfile/components/ServicesPanel/styles';

import type { ServiceWorkNode } from './types';

interface Props {
  index: number;
  work: ServiceWorkNode;
  workSlugs: string[];
  serviceName: string;
}

export const ServiceWork = (props: Props) => {
  const { index, workSlugs, work, serviceName } = props;
  const [open, setOpen] = useState(false);

  const imageUrl = work.illustrationUrls?.[0];

  const openWork = useCallback(() => {
    setOpen(true);
  }, []);

  const closeDialog = () => {
    setOpen(false);
  };

  return (
    <Fragment>
      {imageUrl != null && (
        <S.ServiceWorkCard className={'pr-2 pb-2 flex-xs-100 flex-sm-33 flex-gt-sm-20 layout-row'}>
          <img
            suppressHydrationWarning
            loading={'lazy'}
            src={ImageSourceHelper.fromUrl(imageUrl, { width: 400 })}
            alt={`${work.name} - ${serviceName}`}
            onError={onImageError}
            onClick={openWork}
            className={'cursor-pointer bg-secondary-200 flex-1 shadow-2 rounded-sm width-100'}
          />
        </S.ServiceWorkCard>
      )}
      {open ? (
        <WorkDetailModal open={open} onClose={closeDialog} workSlug={work.slug} workSlugs={workSlugs} index={index} />
      ) : null}
    </Fragment>
  );
};
